import axios from "../http";
let module = "/common";

function getDictByType(type){
    return axios.get(module + '/dict/' + type);
}

export default {
    getDictByType
}
